import axios from "axios";
import { promotionApiConfig } from "@/constant/config";
const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
};

export default {
    getActiveLoginBanners() { 
        return axios({
            method: "GET",
            url: `${promotionApiConfig.getActiveLoginBanners}`,
            headers: headers,
            timeout: 15000,
            withCredentials: true
        });
    },
    getActivePromotions() {
        return axios({
            method: "GET",
            url: `${promotionApiConfig.getActivePromotions}`,
            headers: headers,
            timeout: 15000,
            withCredentials: true
        });
    },
    getAvailableCouponVoucher() {
        return axios({
            method: "GET",
            url: `${promotionApiConfig.getAvailableCouponVoucher}`,
            headers: headers,
            timeout: 15000,
            withCredentials: true
        });
    },
    getMyCouponVoucher() {
        return axios({
            method: "GET",
            url: `${promotionApiConfig.getMyCouponVoucher}`,
            headers: headers,
            timeout: 15000,
            withCredentials: true
        });
    },
    getSurveyQuestion(refId) {
        return axios({
            method: "GET",
            url: `${promotionApiConfig.getSurveyQuestion}/${refId}`,
            headers: headers,
            timeout: 15000,
            withCredentials: true
        });
    },
    redeemBuyVoucher(payload) {
        return axios({
            method: "POST",
            url: `${promotionApiConfig.redeemBuyVoucher}`,
            headers: headers,
            timeout: 15000,
            withCredentials: true,
            data: payload
        });
    },
    submitCouponShowcase(code, payload) {
        const formData = new FormData();
        const clone = { ...payload };
        const fileFields = ['workspaceScreenshotFile', 'videoAnimationFile', 'finalRenderFile'];
        fileFields.forEach(key => {
            if (clone[key] instanceof File) {
                formData.append(key.replace('File', ''), clone[key])
                delete clone[key]
            }
        });
        formData.append("payload", JSON.stringify(clone));
        return axios({
            method: "POST",
            url: `${promotionApiConfig.submitCouponShowcase}/${code}`,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            timeout: 15000,
            withCredentials: true,
            data: formData
        });
    },
}